export const getRandomIntegerBelow = range => Math.floor(Math.random() * range)